<template>
    <div class="sf-employees-grid">
        <button
            v-for="employee in employees"
            :key="employee.id"
            class="sf-employee-card"
            @click="openModal(employee)"
        >
            <LazyImg
                v-if="employee.featuredImage[0]"
                :src="employee.featuredImage[0].url_sm"
                :src-tiny="employee.featuredImage[0].url_tiny"
                :srcset="`
                    ${employee.featuredImage[0].url_xs} 320w,
                    ${employee.featuredImage[0].url_sm} 600w
                `"
                sizes="
                    (max-width: 380px) 320px,
                    600px
                "
                :width="employee.featuredImage[0].width"
                :height="employee.featuredImage[0].height"
                :alt="employee.featuredImage[0].alt || ''"
                :has-focal-point="image?.hasFocalPoint"
                :focal-point="image?.focalPoint"
            />

            <div class="sf-employee-card__name">{{ employee.title }}</div>
            <div class="sf-employee-card__role">{{ employee.subTitle }}</div>
        </button>
    </div>
</template>

<script>
import LazyImg from '~/patterns/atoms/lazy-img/lazy-img';
import { useModalStore } from '~/store/modal';

export default {
    components: {
        LazyImg
    },

    props: {
        employees: {
            type: Array,
            required: true,
            default: null
        }
    },

    data() {
        return {
            modalStore: useModalStore()
        };
    },

    methods: {
        openModal(employee) {
            this.modalStore.open({
                name: 'content',
                title: employee.title,
                subTitle: employee.subTitle,
                content: employee.wysiwyg,
                footer: `<p><a href="mailto:${employee.email}">${employee.email}</a></p>`
            });
        }
    }
};
</script>

<style lang="less" src="./employees-grid.less" />
